import React, { Component } from 'react';
import TableComponent from '@kurtosys/ksys-app-components/dist/components/base/Table';
import { ITableProps, ITableState } from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import Breakpoint from '@kurtosys/ksys-app-components/dist/components/base/Breakpoint';
import { ITableProps as ITableComponentProps } from '@kurtosys/ksys-app-components/dist/components/base/Table/models';
import { IPerformanceRow } from './models/ITablePerformanceRow';
import { computed } from 'mobx';
import { ITableComponentProps as IAppTableComponentProps } from './models/ITableComponentProps';
import { isArrayLike } from '@kurtosys/ksys-app-template/dist/utils/isArrayLike';
import { QueryStore } from '../App/stores/QueryStore';

@inject('appStore', 'tableStore')
@observer
export class Table extends Component<ITableProps, ITableState> {
	static configurationKey: 'table' = 'table';
	static styleKey: 'table' = 'table';
	constructor(props: ITableProps) {
		super(props);
	}

	getTableComponent(props: IAppTableComponentProps | undefined): React.ReactNode {
		if (isArrayLike(props)) {
			const { tableStore } = this.props;
			let queryStore: QueryStore | undefined;
			if (tableStore && tableStore.storeContext) {
				queryStore = tableStore.storeContext.queryStore;
			}
			return props.map((prop, index) => {
				return (<TableComponent key={ index } queryStore={ queryStore } { ...prop as ITableComponentProps<IPerformanceRow> } />);
			});
		}
	}

	@computed
	get renderContent() {
		const { tableStore } = this.props;
		if (tableStore) {
			const { isBreakpointProps, props } = tableStore;
			if (isBreakpointProps(props)) {
				return props.map((breakpoint) => {
					const breakpointProps = {
						key: `${ breakpoint.size }_${ breakpoint.modifier }`,
						[breakpoint.size]: true,
						[breakpoint.modifier]: true,
					};
					return (
						<Breakpoint { ...breakpointProps } >
							{ this.getTableComponent(breakpoint.props) }
						</Breakpoint>
					);
				});
			}
			return this.getTableComponent(props);
		}
	}

	render() {
		const { className, tableStore } = this.props;

		if (!tableStore) {
			return null;
		}

		return (
			<Wrapper className={ className }>
				{ this.renderContent }
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(Table, 'table');
